import React from "react";
import { IconProps } from "../icon";

export const Sliders_03Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M15.05 9H5.5a2.5 2.5 0 010-5h9.55m-6.1 16h9.55a2.5 2.5 0 000-5H8.95M3 17.5a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0zm18-11a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z"
    />
  </svg>
);
